/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import "./index.scss";
import PropTypes from "prop-types";

import TeleIcon from "assets/icons/new-tele.svg";
import FaceIcon from "assets/icons/new-face.svg";
import LinkIcon from "assets/icons/new-link.svg";
import TwitIcon from "assets/icons/new-twi.svg";
import RedditIcon from "assets/icons/new-reddit.svg";
import InstaIcon from "assets/icons/new-ins.svg";

import TeleDarkIcon from "assets/icons/new-tele-dark.svg";
import FaceDarkIcon from "assets/icons/new-face-dark.svg";
import LinkDarkIcon from "assets/icons/new-link-dark.svg";
import TwitDarkIcon from "assets/icons/new-twi-dark.svg";
import RedditDarkIcon from "assets/icons/new-reddit-dark.svg";
import InstaDarkIcon from "assets/icons/new-ins-dark.svg";

const Socials = ({ theme, className }) => {
  const [hover, setHover] = useState(null);

  return (
    <div className={`socialsMain ${className || ""}`}>
      {theme === "dark" ? (
        <div className="content dark">
          <a
            href="https://t.me/joinchat/tCnkNhkPOvE2OTk1"
            target="_blank"
            rel="noreferrer"
            onMouseEnter={() => setHover(0)}
            onMouseLeave={() => setHover(null)}
          >
            <img alt="" src={hover === 0 ? TeleIcon : TeleDarkIcon} />
          </a>
          <a
            href="https://www.facebook.com/Precog-106043198404991"
            target="_blank"
            rel="noreferrer"
            onMouseEnter={() => setHover(1)}
            onMouseLeave={() => setHover(null)}
          >
            <img alt="" src={hover === 1 ? FaceIcon : FaceDarkIcon} />
          </a>
          <a
            href="https://www.linkedin.com/company/74328284/admin/"
            target="_blank"
            rel="noreferrer"
            onMouseEnter={() => setHover(2)}
            onMouseLeave={() => setHover(null)}
          >
            <img alt="" src={hover === 2 ? LinkIcon : LinkDarkIcon} />
          </a>
          <a
            href="https://twitter.com/precog_finance"
            target="_blank"
            rel="noreferrer"
            onMouseEnter={() => setHover(3)}
            onMouseLeave={() => setHover(null)}
          >
            <img alt="" src={hover === 3 ? TwitIcon : TwitDarkIcon} />
          </a>
          <a
            onMouseEnter={() => setHover(4)}
            onMouseLeave={() => setHover(null)}
          >
            <img alt="" src={hover === 4 ? RedditIcon : RedditDarkIcon} />
          </a>
          <a
            href="https://www.instagram.com/precog.finance/"
            target="_blank"
            rel="noreferrer"
            onMouseEnter={() => setHover(5)}
            onMouseLeave={() => setHover(null)}
          >
            <img alt="" src={hover === 5 ? InstaIcon : InstaDarkIcon} />
          </a>
        </div>
      ) : (
        <div className="content">
          <a
            href="https://t.me/joinchat/tCnkNhkPOvE2OTk1"
            target="_blank"
            rel="noreferrer"
          >
            <img alt="" src={TeleIcon} />
          </a>
          <a
            href="https://www.facebook.com/Precog-106043198404991"
            target="_blank"
            rel="noreferrer"
          >
            <img alt="" src={FaceIcon} />
          </a>
          <a
            href="https://www.linkedin.com/company/74328284/admin/"
            target="_blank"
            rel="noreferrer"
          >
            <img alt="" src={LinkIcon} />
          </a>
          <a
            href="https://twitter.com/precog_finance"
            target="_blank"
            rel="noreferrer"
          >
            <img alt="" src={TwitIcon} />
          </a>
          <a>
            <img alt="" src={RedditIcon} />
          </a>
          <a
            href="https://www.instagram.com/precog.finance/"
            target="_blank"
            rel="noreferrer"
          >
            <img alt="" src={InstaIcon} />
          </a>
        </div>
      )}
    </div>
  );
};

Socials.propTypes = {
  theme: PropTypes.string,
  className: PropTypes.string,
};

export default Socials;
